import { useState } from "react";
import { Link } from "react-router-dom";
import { Send, CheckCircle2, Loader2 } from "lucide-react";
import { api, fmtError } from "../lib/api";
import { toast } from "sonner";

export const Footer = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/newsletter/subscribe", { email });
      setDone(true);
      toast.success(r.data.already ? "Vous êtes déjà inscrit·e !" : "Inscription confirmée — email de bienvenue envoyé !");
    } catch (err) {
      toast.error(fmtError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <footer className="border-t border-white/[0.08] bg-black">
      <div className="mx-auto grid grid-cols-1 max-w-7xl gap-12 px-5 py-16 sm:px-8 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <img src="/logo.png" alt="Logo La Console" className="h-10 w-10 border border-white/10 object-cover" />
            <p className="font-display text-xl font-black tracking-tight sm:text-2xl">
              LA CONSOLE <span className="text-amber-500">DES ARTISTES</span>
            </p>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-zinc-500">
            Créations musicales originales pour la publicité, le cinéma et les artistes.
            Licences simples, fichiers haute qualité.
          </p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-zinc-500">Navigation</p>
          <ul className="mt-4 space-y-2 text-sm text-zinc-400">
            <li><Link to="/catalogue" className="transition-colors hover:text-amber-400">Catalogue</Link></li>
            <li><Link to="/artistes" className="transition-colors hover:text-amber-400">Artistes</Link></li>
            <li><Link to="/journal" className="transition-colors hover:text-amber-400">Journal</Link></li>
            <li><Link to="/panier" className="transition-colors hover:text-amber-400">Panier</Link></li>
            <li><Link to="/compte" className="transition-colors hover:text-amber-400">Mon compte</Link></li>
            <li><Link to="/cgv" className="transition-colors hover:text-amber-400">CGV</Link></li>
            <li><Link to="/contact" data-testid="footer-contact" className="transition-colors hover:text-amber-400">Contact &amp; sur-mesure</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.25em] text-zinc-500">Newsletter</p>
          <p className="mt-4 text-sm leading-relaxed text-zinc-500">
            Nouveaux morceaux, artistes et conseils pour vos images — directement dans votre boîte.
          </p>
          {done ? (
            <p className="mt-4 flex items-center gap-2 text-sm text-emerald-400" data-testid="newsletter-success">
              <CheckCircle2 className="h-4 w-4" /> Inscription confirmée, merci !
            </p>
          ) : (
            <form onSubmit={subscribe} className="mt-4 flex gap-2" data-testid="newsletter-form">
              <input
                type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="votre@email.fr" data-testid="newsletter-email"
                className="w-full min-w-0 border border-white/15 bg-transparent px-4 py-3 text-sm outline-none transition-colors focus:border-amber-500"
              />
              <button
                type="submit" disabled={busy} data-testid="newsletter-submit"
                className="flex shrink-0 items-center gap-2 bg-amber-500 px-4 py-3 text-[11px] font-bold uppercase tracking-[0.2em] text-black transition-colors hover:bg-amber-400 disabled:opacity-50"
              >
                {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
                <span className="hidden sm:inline">OK</span>
              </button>
            </form>
          )}
          <p className="mt-3 text-[11px] leading-relaxed text-zinc-600">
            Désinscription en un clic dans chaque email.
          </p>
        </div>
      </div>
      <div className="border-t border-white/[0.06] py-6 text-center text-xs uppercase tracking-[0.25em] text-zinc-600">
        © 2026 La Console des Artistes — Tous droits réservés
      </div>
    </footer>
  );
};
